import { render, staticRenderFns } from "./FakeCustomer.vue?vue&type=template&id=7452cbd7"
import script from "./FakeCustomer.vue?vue&type=script&lang=js"
export * from "./FakeCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports